
export const globalEnv = {
  CODEBUILD_RESOLVED_SOURCE_VERSION: "1a59d0e0d2eed7022c76e5fe7e3a2d75d89145b8"
};
